import Vue from 'vue';
import Router from 'vue-router';
import routes from './router'
import {routerMode} from '../config/env'
import {setWechatTitle, getCookie, initUTMData, isWeiXin, wxLogin, wxLoginAjax} from '../config/mUtils'
import { Tools, App } from 'youshumethod'

Vue.use(Router)
const router = new Router({
	routes,
	mode: routerMode,
    base: '/classroom_yz',
	strict: process.env.NODE_ENV !== 'production',
    scrollBehavior(to, from, savedPosition){
        if (savedPosition) {
            return savedPosition
        } else {
            return { x: 0, y: 0 }
        }
    },
})

router.beforeEach((to, from, next) => {
    console.log("to------------", to);
    console.log("from------------", from);
    //判断首次进入页面
    if(from.fullPath=='/'){
        initUTMData(to.query,to.path.split('/')[1])
    }
    let query = {};
    query = {
        ...query,
        ...to.query
    };
    // 我的、商城未登录
    if ((to.path == '/mall' || to.path == '/yzgxMall') && !query.code && isWeiXin() && !(getCookie('HTTP_X_YS_UID') != '' && getCookie('HTTP_X_YS_USER_TOKEN') != '' && getCookie('HTTP_X_YS_UID') > 0)) {
        wxLogin()
    // 有code且未登录调登录
    } else if (query.code && query.loginType && isWeiXin() && (getCookie('HTTP_X_YS_UID') == '' || getCookie('HTTP_X_YS_USER_TOKEN') == '' || getCookie('HTTP_X_YS_UID') < 0)) {
        wxLoginAjax(to.path, query)
    }else if(query.code && query.loginType && isWeiXin() && query.cust_auth>=0 && getCookie('HTTP_X_YS_UID')){
        wxLoginAjax(to.path, query)
    } else {
        next();
    }
    // next();
});

router.afterEach((transition, from) => {

    if (transition.path) {

        let utmData = {};
        //统计添加utm_source参数
        if(Tools.cookie.get("utm_source")) {
            utmData.utm_source = Tools.cookie.get("utm_source");
        }

        //统计添加utm_medium参数
        if(Tools.cookie.get("utm_medium")) {
            utmData.utm_medium = Tools.cookie.get("utm_medium");
        }
        //统计添加utm_campaign参数
        if(Tools.cookie.get("utm_campaign")) {
            utmData.utm_campaign = Tools.cookie.get("utm_campaign");
        }
        //统计添加utm_term参数
        if(Tools.cookie.get("utm_term")) {
            utmData.utm_term = Tools.cookie.get("utm_term");
        }
        //统计添加utm_content参数
        if(Tools.cookie.get("utm_content")) {
            utmData.utm_content = Tools.cookie.get("utm_content");
        }

        // app环境下记录游客ID
        let look_id;
        if (Tools.isYsApp() && Tools.cookie.get('HTTP_X_YS_UID') > 1) {
            look_id = 1;
        } else if (Tools.isYsApp() && Tools.cookie.get('HTTP_X_YS_UID') < 0) {
            look_id = Tools.cookie.get('HTTP_X_YS_UID');
        }
        try {
            // 自定义全局参数
            sensors.registerPage({
                current_url: document.location.origin + '/classroom_yz' + transition.fullPath,
                referrer: from.fullPath != '/' ? document.location.origin + from.fullPath : '',
                platform: Tools.isYsApp() ? 'app' : 'wechat',
                run_env: Tools.webEnv() == 'weixin' ? 'wechat' : Tools.webEnv(),
                page_name: 'yz' + transition.path.split('/')[1].substring(0,1).toUpperCase() + transition.path.split('/')[1].split('&')[0].substring(1),
                look_id: look_id,
                utm_source: utmData.utm_source ? utmData.utm_source : '',
                utm_medium: utmData.utm_medium ? utmData.utm_medium : '',
                utm_campaign: utmData.utm_campaign ? utmData.utm_campaign : '',
                utm_term: utmData.utm_term ? utmData.utm_term : '',
                utm_content: utmData.utm_content ? utmData.utm_content : ''
            });
            // 手动开启浏览事件 $pageview 采集
            sensors.quick("autoTrackSinglePage");
        } catch (err) {

        }

        // 设置页面标题（微信）
        let title = transition.meta.title;
        setWechatTitle(title);
        // ios-app 支持spa history
        App.didFinishLoad()
    }
});

export default router